import { DialInPhoneNumberRecord } from '../../../services/apiGateway/apiGatewayTypes'

export type DialInFetchStatus = 'nodata' | 'fetching' | 'complete' | 'error'

export interface DialInReducer {
  code: number | null
  codeFetchStatus: DialInFetchStatus
  phoneNumbers: DialInPhoneNumberRecord[]
  selectedPhoneNumber: DialInPhoneNumberRecord['phoneNumber']
  phoneNumberFetchStatus: DialInFetchStatus
}

export const defaultState: DialInReducer = {
  code: null,
  codeFetchStatus: 'nodata',
  phoneNumbers: [],
  selectedPhoneNumber: '',
  phoneNumberFetchStatus: 'nodata'
}

export default defaultState
